import { Map } from 'immutable';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { brandStylesByRelationId } from 'containers/Common/selectors';
import * as Models from 'models';

export function useBrandStylesForRelation(relationId: string): Models.BrandStylesMap {
  const brandStyles = useSelector(brandStylesByRelationId);

  return useMemo(
    (): Models.BrandStylesMap => brandStyles.get(relationId) ?? Map(),
    [relationId, brandStyles],
  );
}
